import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import  styles from './EngagementStats.module.css';
import { getFunctions, httpsCallable } from "firebase/functions";
import { useNotifications } from "../../utils/NotificationContext/NotificationContext";
//import { useInView } from 'react-hook-inview';
import { getCallableCache } from "../../hooks/getCallableCachedPromisData";

const THIRTY_MINUTES = 30 * 60 * 1000;

const EngagementStats = ({shownow = true}) => {
  const { t } = useTranslation();
  const { notify } = useNotifications();
 const [totalDebates, settotalDebates] = useState(0);
 const [totalUsers, settotalUsers] = useState(0);
 const [activeUsers, setactiveUsers] = useState(0);
 const [liveDebates, setliveDebates] = useState(0);
  const [visible, setVisible] = useState(shownow);
  //const [ref, isVisible] = useInView({ triggerOnce: false, threshold: 0.1 });
  
  let scrollTimeout = null;
  let lastScrollY = window.scrollY;
  
  const functions = getFunctions();
  const getEngagementStats = httpsCallable(functions, 'getengagementstats');
  
  useEffect(() => {
    const handleScroll = (e) => {
      var current = window.scrollY;
      if (current > lastScrollY) {
        setVisible(false); // hide on scroll down
      }
      lastScrollY = current;

      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => {
        current = window.scrollY;
		if(current < 1 && shownow == true) {
			setVisible(true); // show after scroll stops
		}
      }, 500);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  
  /*useEffect(() => {
    const fetchengagement = async () => {
		getEngagementStats().then(async (result) => {
			const _totalDebates = result.data.totalDebates;
			if(_totalDebates){
				settotalDebates(_totalDebates);
			}
			
			const _totalUsers = result.data.totalUsers;
			if(_totalUsers){
				settotalUsers(_totalUsers);
			}
			
			const _activeUsers = result.data.activeUsers;
			if(_activeUsers){
				setactiveUsers(_activeUsers);
			}
			
			const _liveDebates = result.data.liveDebates;
			if(_liveDebates){
				setliveDebates(_liveDebates);
			}

		}).catch((error) => {
			notify("error", error.message);
		});
    };
    fetchengagement();
  }, []);*/
  
  useEffect(() => {
	  async function fetchInitialData() {
		const engagement = await getCallableCache('getengagementstats', 'engagement_cache', {}, THIRTY_MINUTES);
		const _totalDebates = engagement.totalDebates;
		if(_totalDebates){
			settotalDebates(_totalDebates);
		}
		
		const _totalUsers = engagement.totalUsers;
		if(_totalUsers){
			settotalUsers(_totalUsers);
		}
		
		const _activeUsers = engagement.activeUsers;
		if(_activeUsers){
			setactiveUsers(_activeUsers);
		}
		
		const _liveDebates = engagement.liveDebates;
		if(_liveDebates){
			setliveDebates(_liveDebates);
		}
	  }

	  fetchInitialData();
  }, []);
  
  return (
    <div className={`${styles["engagement-statss"]} ${styles["mini-engagement-strip"]} ${styles["engagement-stripf"]} ${"fade-in-upf"} ${!visible ? styles.hidden : ''} ${!shownow ? styles.realhidden : ''}`}>
      <div>
        <strong>{liveDebates}</strong>
        <span> {t('engagement.liveDebates')}</span>
      </div>
      <div>
        <strong>{totalUsers}</strong>
        <span> {t('engagement.activeUsers')}</span>
      </div>
      <div>
        <strong>{totalDebates}</strong>
        <span> {t('engagement.totalDebates')}</span>
      </div>
    </div>
  );
};

export default EngagementStats;
